import React from "react";
import { Project } from "../../Objects/Project";
import { useState, useEffect } from "react";
import {
  Button,
} from "@mui/joy";
import { labelValue, htmlLabelValue, stripHtml, sanitizeHtml } from "../Helpers";
import DynamicViewModal from "../DynamicComponents/DynamicViewModal";
import DynamicEditModal from "../DynamicComponents/DynamicEditModal";
import { ApiService } from "../../api/ProjectInfoService";
import { ToastContainer, toast } from "react-toastify";

interface ITalenBoxProps {
  title: string;
  project: Project;
  language: string;
  userIsPrivileged: boolean;
}

const TalenBox = ({ title, project, language , userIsPrivileged }: ITalenBoxProps) => {
  const [langTitle, setLangTitle] = useState<string>("Titel");
  const [description, setDescription] = useState<string>("Beschrijving");
  const [keyWords, setKeyWords] = useState<string>("Trefwoorden");
  const [openEditModal, setOpenEditModal] = React.useState<boolean>(false);
    const [openViewModal, setOpenViewModal] = React.useState<boolean>(false);
  const [values, setValues] = useState<{ label: string; value: string , lang: string}[]>([]);
  const [results, setResults] = useState<string>("Resultaten");

  useEffect(() => {
    if (language === "nl") {
      setValues([
        { label: "Titel", value: sanitizeHtml(project?.titleNl), lang: "titleNl" },
        { label: "Beschrijving", value: sanitizeHtml(project?.descriptionNl), lang: "descriptionNl" },
        { label: "Trefwoorden", value: sanitizeHtml(project?.keyWordsNl), lang: "keyWordsNl" },
        {label: "Resultaten", value: sanitizeHtml(project?.resultNL),  lang: "resultNl"}
      ]);

      setLangTitle(stripHtml(project?.titleNl));
      setDescription(sanitizeHtml(project?.descriptionNl));
      setKeyWords(stripHtml(project?.keyWordsNl));
      setResults(sanitizeHtml(project?.resultNL))
    }
    if (language === "fr") {
      setValues([
        { label: "Titel", value: sanitizeHtml(project?.titleFr), lang: "titleFr" },
        { label: "Beschrijving", value: sanitizeHtml(project?.descriptionFr), lang: "descriptionFr" },
        { label: "Trefwoorden", value: sanitizeHtml(project?.keyWordsFr), lang: "keyWordsFr" },
        {label: "Resultaten", value: sanitizeHtml(project?.resultFR), lang: "resultFr"}
      ]);
      setLangTitle(stripHtml(project?.titleFr));
      setDescription(sanitizeHtml(project?.descriptionFr));
      setKeyWords(stripHtml(project?.keyWordsFr));
      setResults(sanitizeHtml(project?.resultFR))
    }
    if (language === "en") {
      setValues([
        { label: "Titel", value: sanitizeHtml(project?.titleEn), lang: "titleEn" },
        { label: "Beschrijving", value: sanitizeHtml(project?.descriptionEn), lang: "descriptionEn" },
        { label: "Trefwoorden", value: sanitizeHtml(project?.keyWordsEn), lang: "keyWordsEn"},
        {label: "Resultaten", value: sanitizeHtml(project?.resultEN), lang: "resultEn"}
      ]);
      setLangTitle(stripHtml(project?.titleEn));
      setDescription(sanitizeHtml(project?.descriptionEn));
      setKeyWords(stripHtml(project?.keyWordsEn));
      setResults(sanitizeHtml(project?.resultEN))
    }
  }, []);

  
  const handleSave = (data:any) => {
        // map data to correct format
    const mappendata = {
      projectDospId: project.dospId,
 
      titel_Nl: language === "nl" ?  data.find((item: any) => item.lang === "titleNl") ? data.find((item: any) => item.lang === "titleNl")?.value : project.titleNl : null,
      titel_Fr: language === "fr" ? data.find((item: any) => item.lang === "titleFr") ? data.find((item: any) => item.lang === "titleFr")?.value : project.titleFr: null,
      titel_En: language === "en" ?data.find((item: any) => item.lang === "titleEn")? data.find((item: any) => item.lang === "titleEn")?.value : project.titleEn: null,
      description_Nl: language === "nl" ?data.find((item: any) => item.lang === "descriptionNl")? data.find((item: any) => item.lang === "descriptionNl")?.value : project.descriptionNl: null,
      description_Fr: language === "fr" ? data.find((item: any) => item.lang === "descriptionFr")? data.find((item: any) => item.lang === "descriptionFr")?.value : project.descriptionFr: null,
      description_En: language === "en" ?data.find((item: any) => item.lang === "descriptionEn")? data.find((item: any) => item.lang === "descriptionEn")?.value : project.descriptionEn: null,
      results_Nl: language === "nl" ?data.find((item: any) => item.lang === "resultNl")? data.find((item: any) => item.lang === "resultNl")?.value : project.resultNL: null,
      results_Fr: language === "fr" ? data.find((item: any) => item.lang === "resultFr")? data.find((item: any) => item.lang === "resultFr")?.value : project.resultFR: null,
      results_En: language === "en" ?data.find((item: any) => item.lang === "resultEn")? data.find((item: any) => item.lang === "resultEn")?.value : project.resultEN: null,
      keywords_Nl: language === "nl" ?data.find((item: any) => item.lang === "keyWordsNl")? data.find((item: any) => item.lang === "keyWordsNl")?.value : project.keyWordsNl: null,
      keywords_Fr: language === "fr" ? data.find((item: any) => item.lang === "keyWordsFr")? data.find((item: any) => item.lang === "keyWordsFr")?.value : project.keyWordsFr: null,
      keywords_En: language === "en" ?data.find((item: any) => item.lang === "keyWordsEn")? data.find((item: any) => item.lang === "keyWordsEn")?.value : project.keyWordsEn: null,
    }

    ApiService.postProject(mappendata).then((res) => {
      toast.success("Project succesvol aangevraagd om aan te passen");
      setOpenEditModal(false);
    }
    ).catch((error : any) => {
      console.log(error);
      toast.error("Er is iets misgegaan bij het aanvragen om het project aan te passen");
    }
    );

  };
  const onCloseEditModal = () => {
    setOpenEditModal(false);
  };
    const onCloseViewModal = () => {
        setOpenViewModal(false);
    };


  return (
    <>
    <div className="box">
      <h3>
        {title}
        {userIsPrivileged && <Button
          className="headerButton"
          variant="outlined"
          color="neutral"
          onClick={() => setOpenEditModal(true)}
        >
          Wijzig
        </Button>}
      </h3>
      <div className="items">
        {labelValue(langTitle, "Titel")}
        <div onClick={() => setOpenViewModal(true)}>
          {htmlLabelValue(description, "Beschrijving")}
        </div>
        {userIsPrivileged && <DynamicEditModal
          isOpen={openEditModal}
          onClose={onCloseEditModal}
          onSave={handleSave}
          values={values}
          
        ></DynamicEditModal>}
        <DynamicViewModal
            isOpen={openViewModal}
            onClose={onCloseViewModal}
            value={{ label: "Beschrijving", value: description }}
            ></DynamicViewModal>
        {labelValue(keyWords, "Trefwoorden")}
        {htmlLabelValue(results, "Resultaten")}
      </div>
    </div>
    <ToastContainer />
    </>
  );
};

export default TalenBox;
